import { createFileRoute, notFound } from "@tanstack/react-router";
import BrancheDetailPage from "@/pages/BrancheDetailPage";
import NotFound from "@/pages/NotFound";
import { buildRouteHead } from "@/lib/route-head";
import { industries } from "@/data/industries";
import {
  breadcrumbSchema,
  serviceSchema,
  faqSchema,
} from "@/lib/schema";

export const Route = createFileRoute("/branchen/$slug")({
  // Ohne echten 404-Status werten Google & Co. unbekannte Slugs als Soft-404.
  loader: ({ params }) => {
    if (!industries.some((i) => i.slug === params.slug)) {
      throw notFound();
    }
  },
  notFoundComponent: NotFound,
  head: ({ params }) => {
    const industry = industries.find((i) => i.slug === params.slug);
    if (!industry) {
      return buildRouteHead({
        title: "Branche nicht gefunden | Enno & Jens",
        description: "Diese Branche existiert nicht. Zur Übersicht aller Branchen.",
        path: `/branchen/${params.slug}`,
        noIndex: true,
      });
    }
    const path = `/branchen/${industry.slug}`;
    const image = `/images/industries/${industry.slug}-1024.webp`;
    const scripts = [
      serviceSchema({
        name: `Webdesign & SEO für ${industry.title}`,
        description: industry.description,
        path,
        image,
        serviceType: "Webdesign & Digitalisierung",
        audienceType: industry.title,
      }),
      breadcrumbSchema([
        { name: "Startseite", path: "/" },
        { name: "Branchen", path: "/branchen" },
        { name: industry.title, path },
      ]),
      ...(industry.faq && industry.faq.length ? [faqSchema(industry.faq)] : []),
    ];
    return buildRouteHead({
      title: `${industry.heroTitle} | Agentur Enno & Jens`,
      description: `Professionelle Webseiten für ${industry.title} in Wernigerode & Harz: ${industry.description}`,
      path,
      image,
      imageAlt: `Webdesign für ${industry.title} aus Wernigerode`,
      imageWidth: 1024,
      imageHeight: 697,
      scripts,
    });
  },
  component: BrancheDetailPage,
});
